import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useGameMatchList } from '@/modules/game/match/model/list';
import { duplicateService } from '@/services/duplicate';

export function useDuplicateList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { fetchAllMatches, gameMatchCache } = useGameMatchList();

    const { list, total, fetchList } = useBaseListView({
        request: duplicateService.item.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            loadInitialData: fetchAllMatches,
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            transformResponse: (list: any[]) =>
                list.map(item => ({ ...item, matchName: gameMatchCache.value.get(item.matchId)?.label ?? '' }))
        }
    });

    const actions = {
        disable: crudAction.confirmAndDisable({
            request: duplicateService.item.disable,
            onSuccess: () => fetchList()
        }),
        enable: crudAction.confirmAndEnable({
            request: duplicateService.item.enable,
            onSuccess: () => fetchList()
        }),
        remove: crudAction.confirmAndRemove({
            request: duplicateService.item.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, actions };
}
